<template>
  <div>

    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>
    <!-- v-if="!isSpinnerShow && totalEntries != 0" -->
    <div class="dataTables_wrapper dt-bootstrap4">

      <!-- <div class="row justify-content-end mt-2">
        <div class="col-auto pt-2">
          <span>
            {{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}
          </span>
        </div>
        <div class="col-auto">
          <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
            @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
        </div>
      </div> -->

      <div class="row" v-if="!isSpinnerShow && totalEntries != 0">
        <div class="col-sm-12 overflow-auto">
          <b-table
            striped
            hover
            bordered
            class="apptTable"
            :fields="fields"
            :items="items">
            <template #cell(index)="data">
              {{ data.index + startPage }}
            </template>
            <template #cell(image)="data">
              <img class="profile-image-md rounded-circle" :src="getImage(data.item)" />
            </template>
            <template #cell(title)="data">
              <div class="font-weight-bold">{{ data.item.title }}</div>
            </template>
            <template #cell(createDate)="data">
              <div>{{ getDate(data.item.createDate) }}</div>
            </template>
            <template #cell(action)="data">
              <b-button
                @click="onDataEdit(data.item)"
                tabindex="0"
                variant="outline-primary">
                <i class="fal fa-eye"></i>
              </b-button>
              <b-button
                @click="onDataDelete(data.item)"
                tabindex="1"
                variant="outline-danger"
                class="ml-2">
                <i class="fal fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  handleSessionExpired,
  setReturnData,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "ConsentFormView",
  data() {
    return {
      isSpinnerShow: false,

      filterObj: {},
      outlet: [],

      items: [],

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,

      exportHeaders: [],
      exportData: [],
      exportFileName: "",
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "image",
          label: '',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
          sortable: false,
        },
        {
          key: "title",
          label: 'Form Name',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: false,
        },
        {
          key: "createDate",
          label: 'Created Date',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        // {
        //   key: "signed",
        //   label: "Total Signed",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "align-middle",
        // },
        {
          key: "action",
          label: " Action",
          thClass: "thead-themed align-middle",
          tdClass: " align-middle text-center",
        },
      ];
    },
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
  },
  methods: {
    getDate(date) {
      let temp = moment.unix(date)
      return temp.format('DD/MM/YYYY')
    },
    getImage(data) {
      return require('@/assets/image/icon/list.png')
    },

    async setItems(filterObj) {
      this.filterObj = filterObj;

      this.isSpinnerShow = true;

      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: 'https://bebusiness.tunai.io/consent',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.consents.sort((a, b) => b['createDate'] - a['createDate'])

          var retData = setReturnData(result, response.data.count, $vm.page)
          $vm.items = retData.result
          $vm.totalEntries = response.data.count;
          $vm.totalPage = retData.totalPage;

          $vm.startPage = retData.startPage;
          $vm.endPage = retData.endPage;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.isSpinnerShow = false;
    },

    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setItems(this.filterObj);
      }
    },
    onDataEdit(item) {
      this.$emit('onEditForm', item)
    },
    onDataDelete(item) {
      this.$emit('onDeleteForm', item)
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);

    this.setItems()
  },
};
</script>
